import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'

Vue.use(VueApexCharts)

Vue.component('apex-chart', VueApexCharts)
